export default __webpack_public_path__ + "static/media/animation_button.c83ea1c8.gif";